import React,{Component} from 'react';
import { observer } from 'mobx-react';
import BottomBtnView from './BottomBtnView';
import TotalView from './TotalView';


import './BottomView.less'
@observer
class BottomView extends Component{

    constructor(prop){
        super(prop);
    }

    
    render(){
        const {model,config,clickAction,openChoose} = this.props.param;

        return (
            <div className='bottomView'>
                <TotalView model={model}/>
                <BottomBtnView model={config} openChoose ={openChoose} clickAction={clickAction}/>
            </div>
        );
    }
}
export default BottomView;